import React, { useState, useEffect } from "react";

import UserService from "../services/user.service";
import { Container, Row, Col } from "react-bootstrap/";

import {
  Eye,
  Star,
  Flower2,
  Heart,
  ShieldCheck,
  People,
  Award,
  Globe,
  Stars,
} from "react-bootstrap-icons";

import wsp from "../assets/wsp.png";

import "./Home.css";

const valores = [
  {
    icono: <Flower2 />,
    titulo: "Humildad",
    texto:
      "Reconociendo nuestros defectos para mejorarlos y al mismo tiempo conocemos cuáles son nuestras virtudes para llevarlas a su máxima expresión.",
  },
  {
    icono: <Heart />,
    titulo: "Pasión",
    texto:
      "Comprometiéndonos con nuestras fuerzas, el corazón, el alma y la mente en todo lo que emprendamos.",
  },
  {
    icono: <ShieldCheck />,
    titulo: "Integridad",
    texto:
      "Siendo muy transparentes con nuestro personal, proveedores y clientes.",
  },
  {
    icono: <People />,
    titulo: "Colaboración",
    texto:
      "Incentivando el trabajo en equipo para poder crear un esfuerzo sinérgico.",
  },
  {
    icono: <Award />,
    titulo: "Compromiso",
    texto:
      "Brindando nuestros servicios y ofreciendo nuestra ayuda tanto al momento de generar la venta como en el post-venta.",
  },
  {
    icono: <Globe />,
    titulo: "Coherencia",
    texto: "Entre nuestros valores y nuestros objetivos.",
  },
  {
    icono: <ShieldCheck />,
    titulo: "Confianza",
    texto:
      "Evitando defraudar a nuestros clientes, proveedores y personal, considerando que la base de una relación en el tiempo es la confianza mutua.",
  },
  {
    icono: <Stars />,
    titulo: "Calidad",
    texto: "Buscando en todo momento la excelencia.",
  },
];

const Home = () => {
  const [content, setContent] = useState("");

  useEffect(() => {
    UserService.getPublicContent().then(
      (response) => {
        setContent(response.data);
      },
      (error) => {
        const _content =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();

        setContent(_content);
      }
    );
  }, []);

  return (
    
    <div className="home">
      
    </div>
  );
};

export default Home;
